<template>
  <div>
    <label for="password">Mot de passe</label>
    <input
      type="password"
      name="password"
      id="password"
      :value="modelValue"
      @input="updateValue"
      required
      placeholder="Votre mot de passe"
    />
    <div class="password-rules">
      <div class="rule" v-for="rule in rules" :key="rule.regex">
        <div>{{ rule.message }}</div>
        <div>{{ rule.valid ? "✅" : "❌" }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
export default {
  props: {
    modelValue: String,
  },
  emits: ["update:modelValue", "passwordvalid"],
  setup(props, { emit }) {
    const rules = ref([
      {
        message: "Au moins 1 caractère minuscule requis.",
        regex: /[a-z]+/,
        valid: false,
      },
      {
        message: "Au moins 1 caractère majuscule requis.",
        regex: /[A-Z]+/,
        valid: false,
      },
      { message: "Au moins 1 chiffre requis.", regex: /[0-9]+/, valid: false },
      { message: "8 charactèrs minimum.", regex: /.{8,}/, valid: false },
    ]);

    const updateValue = (e) => {
      let valid = true;
      for (const rule of rules.value) {
        rule.valid = rule.regex.test(e.target.value);
        if (!rule.valid) {
          valid = false;
        }
      }
      emit("passwordvalid", valid);
      emit("update:modelValue", e.target.value);
    };

    return {
      rules,
      updateValue,
    };
  },
};
</script>

<style lang="scss" scoped>
label {
  font-size: 1em;
  padding-bottom: 0.5em;
}
input {
  padding: 1em;
  margin-bottom: 0.625rem;
  height: 3.125;
  width: 100%;
  border: 1px solid #c4c4c4;
  border-radius: 3px;
  font-size: 0.875rem;
}
.password-rules {
  padding-left: 1rem;
  padding-right: 1rem;
  margin-bottom: 1rem;
  width: 100%;
  .rule {
    display: flex;
    justify-content: space-between;
  }
}
</style>